import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useQuery } from '@sequencehq/api'
import { SECONDS } from '@sequencehq/utils/dates'

export const useManualTask = ({
  taskId,
  poll = false
}: {
  taskId: string | null
  poll?: boolean
}) => {
  const manualTaskQuery = useQuery(
    dashboardv99990101Client.getManualTask,
    { id: taskId ?? '' },
    {
      enabled: !!taskId,
      refetchInterval: poll
        ? query =>
            query.state.data?.status === 'PENDING' ? 5 * SECONDS : false
        : undefined
    }
  )
  return {
    isPending: manualTaskQuery.isPending,
    manualTask: manualTaskQuery.data,
    automationExecutionId: manualTaskQuery.data?.executorWorkflowExecutionId
  }
}
